import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space4 } = theme();

  return StyleSheet.create({
    titleContainer: {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: space4,
    },
  });
};

export { style };
